import { Typography, Divider, Box, Stack, Icon, Paper } from '@ace-clublabs/shared-component-library';

export interface StatelessConfirmationItemDetails {
  title?: string;
  showDate?: boolean;
  dateTitle?: string;
  details?: string | JSX.Element;
  additionalDetails?: string | JSX.Element;
  effectiveDate?: string;
  iconName?: any;
  cardLastFour?: string;
  className?: string;
  autoPayEnrolled?: boolean;
  isMonthlyBillPlan?: boolean;
  downloadMembershipCard?: boolean;
  mask?: boolean;
}

export interface ConfirmationCardProps {
  cardTitle: string;
  items: StatelessConfirmationItemDetails[];
}

export const StatelessConfirmationCard = ({ cardTitle, items }: ConfirmationCardProps) => {
  return (
    <Box sx={{ padding: '0', height: 'fit-content' }}>
      <Typography variant="h6" sx={{ fontWeight: '500', padding: '1rem' }} className="confirmation-card-title">
        {cardTitle}
      </Typography>
      <Divider variant="fullWidth" />
      <Stack sx={{ padding: '1rem' }} gap="1rem">
        {items.map((item) =>
          item.autoPayEnrolled !== undefined ? (
            <Paper sx={{ backgroundColor: '#F7F5F1' }}>
              <Typography
                className={`confirmation-item-${item.className}`}
                variant="b3Regular"
                sx={{ color: '#404040', padding: '0.5rem' }}
              >
                Auto Pay: <strong>{item.autoPayEnrolled ? 'Enrolled' : 'Not Enrolled'}</strong>
              </Typography>
            </Paper>
          ) : (
            <Box key={item.title} className={`confirmation-item-${item.className}`}>
              <Stack direction="row" alignItems="center" gap="0.375rem" justifyContent="space-between">
                <Typography variant="b3Regular" className="confirmation-item-title">
                  {item.title}
                </Typography>
                {item.showDate && (
                  <Typography variant="b3Regular" className="confirmation-item-subtitle">
                    {item.dateTitle}
                  </Typography>
                )}
              </Stack>
              <Stack direction="column">
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography
                    variant="b1Medium"
                    sx={{ fontWeight: '500', overflowWrap: 'anywhere' }}
                    className="confirmation-item-detail"
                    data-qm-block={item.mask ? 'true' : 'false'}
                  >
                    {item.details}
                  </Typography>
                  {item.cardLastFour && (
                    <Stack direction="row" alignItems="center" gap="0.375rem">
                      {item.iconName && (
                        <Icon
                          iconName={item.iconName}
                          sx={{ fontSize: '2.125rem' }}
                          className="confirmation-item-card-icon"
                        ></Icon>
                      )}
                      <Typography className="confirmation-item-card-last-four" variant="b1Medium">
                        •••• {item.cardLastFour}
                      </Typography>
                    </Stack>
                  )}
                  {item.effectiveDate && (
                    <Stack direction="row" alignItems="center" gap="0.375rem">
                      <Typography className="confirmation-item-effective-date" variant="b1Medium">
                        {item.effectiveDate}
                      </Typography>
                    </Stack>
                  )}
                </Stack>
                {item.additionalDetails && (
                  <Typography
                    variant="b3Regular"
                    className="confirmation-item-additional-details"
                    sx={{ overflowWrap: 'anywhere', color: '#7527B9' }}
                  >
                    {item.additionalDetails}
                  </Typography>
                )}
              </Stack>
            </Box>
          )
        )}
      </Stack>
    </Box>
  );
};
